export const globalConst = {
  // 전파세기
  rssiWarningdBm: -90,
  rssiMinimum: -91,
  rssiMaximum: -140,
  //기본 이미지 크기
  defaultImageWidth: 320,
  defaultImageHeight: 144,
  //이미지 크기 제한
  limitImageWidth: 600,
  limitImageHeight: 300,
  // RSRP 설치 판단 구간
  rsrpWarning: -100, // -90 ~ -100
  rsrpBad: -110, // -100 ~ -110  (<-110 은 설치불가 조건 포함)
  // RSRQ 신호품질 (LTE-M Cat-M1 기준) - chip 표시용
  rsrqGood: -10, // >= -10: 좋음 (초록)
  rsrqWarning: -15, // -15 ~ -10: 보통 (주황), < -15: 나쁨 (빨강)
  // RSRQ 설치 판단 구간
  rsrqInstallWarning: -13, // -10 ~ -13
  rsrqInstallBad: -16, // -13 ~ -16  (<-16 은 설치불가)
  // 전파 품질 chip 표시 여부
  showLinkquality: true,
}

export const globalText = {
  installInside: '내부설치',
  installOutside: '외부설치',
}

export enum meterReadEnum {
  ANALOG = '기계식 계량기',
  DIGITAL = '디지털 계량기',
  GAS = '도시가스 계량기',
  PRV = '감압 압력게이지',
}

export const recognizedTypeHandler = (type: string) => {
  switch (type) {
    case 'analog':
      return '기계식 계량기'
    case 'digital':
      return '디지털 계량기'
    case 'gas':
      return '가스 검침기'
    case 'PRV':
      return '감압 압력게이지'
    default:
      return '기계식 계량기'
  }
}

/** 설치자가 직접 선택하는 설치 방식 (설치 기록으로 저장된다) */
export enum installMethodEnum {
  INSIDE = '내부설치',
  OUTSIDE = '외부설치',
  CANNOT_INSTALL = '설치불가',
}

/**
 * RSRP(전파세기) x RSRQ(전파품질) 조합으로 산출하는 신호 등급.
 * 설치 방식(installMethodEnum)과는 별개의 개념이므로 혼용하지 않는다.
 */
export enum signalGradeEnum {
  GOOD = '양호',
  NORMAL = '보통',
  NEED_CHECK = '확인필요',
}
/**
 * 임시 의성 분구 (다인, 비안, 사곡, 안사, 안평)
 */
export enum dividedDistrictUiseongEnum {
  DAIN = '다인면',
  BIAN = '비안면',
  SAGOK = '사곡면',
  ANSA = '안사면',
  ANPYEONG = '안평면',
}
/**
 * 임시 진주용 서버주기
 */
export const serverCycleLabels: Record<any, string> = {
  1: '1시간',
  6: '6시간',
}

export enum ImageProcessStatusEnum {
  COMPLETE = '정상',
  FIX = '수정됨',
  DIGIT = '자릿수 오류',
  FAIL = '인식불가',
  IMGERR = '이미지 오류',
  DANGER = '비정상 사용량',
  WARNING = '검침값 확인 필요',
}

/**
 * 검침값 수정 버튼 등에서 processStatus에 따라 MUI 색상을 매핑.
 * CustomerTargetImageListModal / LeakDetailModals / FlaggedReviewDetailModal 공용.
 * (CustomerStatus / Hmd 모달은 성격이 달라 자체 매핑을 유지)
 */
export const processStatusButtonColor = (
  status: string
): 'success' | 'warning' | 'error' | 'info' | undefined => {
  switch (status) {
    case 'COMPLETE':
      return 'success'
    case 'DIGIT':
    case 'WARNING':
      return 'warning'
    case 'FAIL':
    case 'IMGERR':
    case 'DANGER':
      return 'error'
    case 'FIX':
      return 'info'
    default:
      return undefined
  }
}

export const imageModeConst = {
  recentImage: 'RECENT_IMAGE_MODE',
  todayFirstImageIfNull: 'TODAY_FIRST_IF_NULL_RECENT_IMAGE_MODE',
}
/**
 * 수용가 번호에 해당 지자체에서 관리하는 번호 처럼 "-" 추가
 *
 * @param officeId : 해당 수용가 번호의 officeId
 * @param number : 해당 수용가 번호
 */
export const globalFormatWithHyphens = (officeId: any, number: any) => {
  const numLength: {[key: string]: number[]} = {
    '7300': [12],
    B300: [13],
    B500: [13],
    '4001': [14],
    '4002': [14],
    '8400': [13, 14], // 13자리와 14자리를 허용
    A800: [15],
    '6501': [12],
  }

  const formatPatterns: {[key: string]: RegExp} = {
    '7300': /(\d{3})(\d{3})(\d{4})(\d{2})/,
    B300: /(\d{2})(\d{2})(\d{3})(\d{6})/,
    B500: /(\d{2})(\d{3})(\d{8})/,
    '4001': /(\d{1})(\d{2})(\d{3})(\d{3})(\d{5})/,
    '4002': /(\d{1})(\d{2})(\d{3})(\d{3})(\d{5})/,
    '8400': /(\d{2})(\d{3})(\d{4})(\d{4})/,
    A800: /(\d{3})(\d{3})(\d{6})(\d{3})/,
    '6501': /(\d{5})(\d{2})(\d{5})/,
  }

  const formatReplacedPatterns: {[key: string]: string} = {
    '7300': '$1-$2-$3-$4',
    B300: '$1-$2-$3-$4',
    B500: '$1-$2-$3',
    '4001': '$1-$2-$3-$4-$5',
    '4002': '$1-$2-$3-$4-$5',
    '8400': '$1-$2-$3-$4',
    A800: '$1-$2-$3-$4',
    '6501': '$1-$2-$3',
  }

  if (number == null) return ''
  let numToString = number.toString()

  const requiredLengths = numLength[officeId]
  const pattern = formatPatterns[officeId]
  const replacedPattern = formatReplacedPatterns[officeId]

  if (!requiredLengths || !requiredLengths.includes(numToString.length) || !pattern) {
    return numToString
  }

  if (officeId === '8400' && numToString.length === 13) {
    return numToString.replace(pattern, replacedPattern)
  }

  if (officeId === '8400' && numToString.length === 14) {
    const formatted = numToString.slice(0, 13).replace(pattern, replacedPattern)
    const lastDigit = numToString.slice(13)
    return `${formatted}-${lastDigit}`
  }

  if (officeId === '6101' && numToString.length === 15) {
    const formatted = numToString.slice(0, 13).replace(pattern, replacedPattern)
    const lastDigit = numToString.slice(13)
    return `${formatted}-${lastDigit}`
  }

  return numToString.replace(pattern, replacedPattern)
}

/**
 * 엑셀 다운로드 시 양식 지정 할때 수용가 (하이픈) 추가
 */
export const HyphensOfficeHandler = (id: any) => {
  const allowed = [
    '00',
    '7300',
    'B300',
    'B500',
    'B5',
    '4001',
    '4002',
    '8400',
    'A800',
    '61',
    '6100',
    '6501',
  ]
  if (allowed.includes(id)) {
    return true
  }
  const idPrefix = id.slice(0, 2)
  const allowedPrefixes = allowed.map((item) => item.slice(0, 2))
  if (allowedPrefixes.includes(idPrefix)) {
    return true
  }

  return false
}

export const mergeImages = (
  originalImageUrl: string,
  revisionImageUrl: string
): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    if (!ctx) {
      return reject('Canvas context not available')
    }

    const originalImg = new Image()
    originalImg.crossOrigin = 'anonymous'
    originalImg.src = originalImageUrl

    const revisionImg = new Image()
    revisionImg.crossOrigin = 'anonymous'
    revisionImg.src = revisionImageUrl

    originalImg.onload = () => {
      canvas.width = originalImg.width
      canvas.height = originalImg.height
      ctx.drawImage(originalImg, 0, 0, originalImg.width, originalImg.height)
      revisionImg.onload = () => {
        ctx.drawImage(revisionImg, 0, 0, revisionImg.width, revisionImg.height)
        resolve(canvas.toDataURL('image/png'))
      }

      revisionImg.onerror = () => {
        console.error(`Failed to load revision image from URL: ${revisionImageUrl}`)
        resolve(canvas.toDataURL('image/png'))
      }
    }

    originalImg.onerror = () => {
      reject(`Failed to load original image from URL: ${originalImageUrl}`)
    }
  })
}

/**
 * 페이지
 */
export const globalRowsPerPageOptions = [30, 50, 100, 200]

/**
 * 단말기 번호에 Hypen 추가 (자릿수 맞는 경우에만)
 *
 * @param number : 해당 단말기 번호
 */
export const globalSerialNumberFormatWithHyphens = (number: any) => {
  if (!number) {
    return ''
  }
  let numToString = number.toString()

  const requiredLengths = [10]
  const pattern = /(\d{2})(\d{2})(\d{6})/
  const replacedPattern = '$1-$2-$3'

  if (!requiredLengths || !requiredLengths.includes(numToString.length) || !pattern) {
    return numToString
  }

  return numToString.replace(pattern, replacedPattern)
}

export const busanHeadPlaceHolder = (serverName: any, officeId: any) => {
  let Id = String(officeId).slice(0, 2)

  switch (serverName) {
    case 'prod':
    case 'dev':
      switch (Id) {
        case '13':
          return '수용가 번호를 검색해주세요'
        default:
          return '수용가 번호 / 이름 / 주소 를 검색해주세요.'
      }

    default:
      return '수용가 번호 / 이름 / 주소 를 검색해주세요.'
  }
}

/**
 * firmwareVersion 수정필요
 */
export const serverList = [
  {
    id: 'prod',
    label: '미터리움 M',
    lwm2mIp: 'meterarium.com',
    lwm2mPort: '5684',
    imageIpPort: 'meterarium.com:8684',
    firmwareVersion: 'TM800L_101_800',
  },
  {
    id: 'dev',
    label: '미터리움(dev)',
    lwm2mIp: '210.95.251.225',
    lwm2mPort: '5684',
    imageIpPort: '210.95.251.225:8684',
    firmwareVersion: 'TM800L_101_800',
  },
  {
    id: 'bonghwa',
    label: '봉화',
    lwm2mIp: '203.237.4.253',
    lwm2mPort: '5684',
    imageIpPort: '203.237.4.253:8092',
    firmwareVersion: 'TM800L_101_801',
  },
  {
    id: 'mokpo',
    label: '목포',
    lwm2mIp: '61.80.123.220',
    lwm2mPort: '5684',
    imageIpPort: '61.80.123.220:8684',
    firmwareVersion: 'TM800L_101_802',
  },
  {
    id: 'suncheon',
    label: '순천',
    lwm2mIp: '211.114.155.251',
    lwm2mPort: '5684',
    imageIpPort: '211.114.155.251:8684',
    firmwareVersion: 'TM800L_101_803',
  },
  {
    id: 'cheonan',
    label: '천안',
    lwm2mIp: '211.114.153.108',
    lwm2mPort: '5684',
    imageIpPort: '211.114.153.108:8684',
    firmwareVersion: 'TM800L_101_804',
  },
  {
    id: 'gyeryong',
    label: '계룡',
    lwm2mIp: 'hycheck-gyeryong.com',
    lwm2mPort: '5684',
    imageIpPort: 'hycheck-gyeryong.com:8092',
    firmwareVersion: 'TM800L_101_805',
  },
  {
    id: 'goesan',
    label: '괴산',
    lwm2mIp: '112.165.176.210',
    lwm2mPort: '5684',
    imageIpPort: '112.165.176.210:8092',
    firmwareVersion: 'TM800L_101_806',
  },
  {
    id: 'boseong',
    label: '보성',
    lwm2mIp: '152.99.165.17',
    lwm2mPort: '5684',
    imageIpPort: '152.99.165.17:8684',
    firmwareVersion: 'TM800L_101_807',
  },
  {
    id: 'sejong',
    label: '세종',
    lwm2mIp: '210.90.169.69',
    lwm2mPort: '5684',
    imageIpPort: '210.90.169.69:8684',
    firmwareVersion: 'TM800L_101_808',
  },
  {
    id: 'eumseong',
    label: '음성',
    lwm2mIp: '59.31.69.193',
    lwm2mPort: '5684',
    imageIpPort: '59.31.69.193:8092',
    firmwareVersion: 'TM800L_101_809',
  },
  {
    id: 'uiwang',
    label: '의왕',
    lwm2mIp: '14.63.185.82',
    lwm2mPort: '5684',
    imageIpPort: '14.63.185.82:8684',
    firmwareVersion: 'TM800L_101_810',
  },
]

/**
 *
 * @param status customerStatus 수용가 상태
 * @returns String
 */
export const customerStatusHandler = (status: any) => {
  switch (status) {
    case 'as':
      return 'as'
    case 'remove':
      return '철거'
    case 'disused':
      return '폐전'
    default:
      return ''
  }
}
